import { createTheme } from '@mui/material/styles';
import { Themes } from 'src/styles/variables';

export default createTheme({
  palette: Themes.ADMIN.palette,
});
